import Anchor from './Anchor';
import AnchorLink from './AnchorLink';

Anchor.Link = AnchorLink;
export default Anchor;



// WEBPACK FOOTER //
// ./components/anchor/index.tsx